import { render, staticRenderFns } from "./MobileDetailsAdvantages.vue?vue&type=template&id=9dd92e60&"
import script from "./MobileDetailsAdvantages.vue?vue&type=script&lang=js&"
export * from "./MobileDetailsAdvantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dd92e60')) {
      api.createRecord('9dd92e60', component.options)
    } else {
      api.reload('9dd92e60', component.options)
    }
    module.hot.accept("./MobileDetailsAdvantages.vue?vue&type=template&id=9dd92e60&", function () {
      api.rerender('9dd92e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/mobiledetails/MobileDetailsAdvantages.vue"
export default component.exports